import { render } from "./ScrolSet.vue?vue&type=template&id=6008ed56&scoped=true"
import script from "./ScrolSet.vue?vue&type=script&lang=js"
export * from "./ScrolSet.vue?vue&type=script&lang=js"

import "./ScrolSet.vue?vue&type=style&index=0&id=6008ed56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6008ed56"]])

export default __exports__